import http from './http';

// 钉钉扫码登录
const qrcodeLogin = (params) => {
  return http({
    url: '/login/ding',
    method: 'GET',
    params,
  });
};

// 用户名密码登录
const accountLogin = (data) => {
  return http({
    url: '/login/employee',
    method: 'POST',
    data,
  });
};

// 登出
const fetchLogout = () => {
  return http({
    url: '/logout',
    method: 'POST',
  });
};

// 获取当前员工信息
const fetchEmployeeCurrent = (params?: any) => {
  return http({
    url: '/employee/current',
    params,
  });
};

// 短信登录获取验证码
const getSMSLoginCode = (params) => {
  return http({
    url: '/login/sms/send',
    method: 'GET',
    params,
  });
};

// 短信登录
const loginBySMSCode = (data) => {
  return http({
    url: '/login/employee',
    method: 'POST',
    data,
  });
};

// 时区
const getSysTimeZoneList = (params) => {
  return http({
    url: '/open/dict/timezones',
    method: 'GET',
    params,
  });
};

// 语言
const getSysLanguageList = () => {
  return http({
    url: '/open/dict/languages',
    method: 'GET',
  });
};

// 商户配置
const getTenantBaseConfig = () => {
  return http({
    url: '/open/tenant/base',
    method: 'GET',
  });
};

// 用户配置
const getUserBaseConfig = () => {
  return http({
    url: '/employee/customize/info',
    method: 'GET',
  });
};

// 更新用户语言、时区配置
const updateUserIntlConfig = (data) => {
  return http({
    url: '/employee/customize',
    method: 'POST',
    data,
  });
};

// 获取登录方式
const getLoginMethodList = () => {
  return http({
    url: '/login/types',
    method: 'GET',
  });
};

// 获取用户token
const getUserLoginToken = (data) => {
  return http({
    url: '/v2/login',
    method: 'POST',
    data,
  });
};

// 商户配置
const getTenantSysConfig = () => {
  return http({
    url: '/sys/config',
  });
};

// 商户配置
const getMobileRegionList = () => {
  return http({
    url: '/open/dict/regions',
    method: 'GET',
  });
};

export {
  qrcodeLogin,
  accountLogin,
  fetchLogout,
  fetchEmployeeCurrent,
  getSMSLoginCode,
  loginBySMSCode,
  getSysTimeZoneList,
  getSysLanguageList,
  getTenantBaseConfig,
  getUserBaseConfig,
  updateUserIntlConfig,
  getLoginMethodList,
  getUserLoginToken,
  getTenantSysConfig,
  getMobileRegionList,
};
